import { AxiosPromise } from 'axios';
import request from '@/utils/request';
import { OfferDeliveryType } from './type';

/**
 * 获取账号与数字商品的发货方式
  GET /product/product-common/getFixationDeliveryType
  接口ID：263628571
  接口地址：https://app.apifox.com/link/project/4822917/apis/api-263628571
 */
export const getOfferAutomicDeliverType = (): AxiosPromise<OfferDeliveryType[]> => {
  return request({
    url: '/product/product-common/getFixationDeliveryType',
    method: 'get'
  });
};
